/**
 * Millisecond based constants
 */
export const ONE_SECOND_MS = 1000;
export const ONE_MINUTE_MS = 60 * ONE_SECOND_MS;
export const ONE_HOUR_MS = 60 * ONE_MINUTE_MS;
export const ONE_DAY_MS = 24 * ONE_HOUR_MS;
export const ONE_WEEK_MS = 7 * ONE_DAY_MS;
export const ONE_MONTH_MS = 30 * ONE_DAY_MS;

/**
 * Second based constants
 */
export const ONE_YEAR_SEC = 60 * 60 * 24 * 365;
export const ONE_MONTH_SEC = 60 * 60 * 24 * 30;
export const ONE_WEEK_SEC = 60 * 60 * 24 * 7;
export const ONE_DAY_SEC = 60 * 60 * 24;
export const ONE_HOUR_SEC = 60 * 60;
